import React, { Component } from 'react'
import { Grid } from '@material-ui/core'
import RiskDrawer from '../FilterSet/FilterChips/Risks'
import TypeDrawer from '../FilterSet/FilterChips/Type'
import CatDrawer from '../FilterSet/FilterChips/Categories'
import CountriesDrawer from '../FilterSet/FilterChips/Country'
import YearDrawer from '../FilterSet/FilterChips/Year'
import ThresholdDrawer from '../FilterSet/FilterChips/Threshold'

class Chips extends Component {
  render() {
    return (
      <Grid container>
        <Grid item>
          <TypeDrawer />
        </Grid>
        <Grid item>
          <RiskDrawer />
        </Grid>
        <Grid item>
          <CatDrawer />
        </Grid>
        <Grid item>
          <CountriesDrawer />
        </Grid>
        <Grid item>
          <YearDrawer />
        </Grid>
        <Grid item>
          <ThresholdDrawer />
        </Grid>
      </Grid>
    )
  }
}

export default Chips
